"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/**
 * Used with aria-describedby to hide text visually, but not from screen readers
 * @link https://snook.ca/archives/html_and_css/hiding-content-for-accessibility
 **/

const VisuallyHidden = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "esqcxxz0"
} : {
  target: "esqcxxz0",
  label: "VisuallyHidden"
})(process.env.NODE_ENV === "production" ? {
  name: "1dja9su",
  styles: "position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);white-space:nowrap;border:0"
} : {
  name: "1dja9su",
  styles: "position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);white-space:nowrap;border:0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var _default = exports.default = VisuallyHidden;